//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfCollapsibleItems",
    props: {
        active: { type: String, required: false, default: null },
        items: { type: Array, required: true }
    },
    methods: {
        selectControl(ev, item) {
            const shift = ev.shiftKey; const
                { type } = item;
            this.$emit("select", { type, shift });
            this.$root.$emit("showCheckedSaveBtn", false);
        },
        checkActive(item) {
            return item.type === this.active ? "active" : "";
        }
    }
};
